export default "__VITE_ASSET__5qAY02XL__"